import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    statusNames: [],
    statusRights: [],
    palletPlanning: {
      loading: false,
      orders: [],
      pallets: [],
      truck: {},
      selectedProducts: [],
      settings: {},
      selectedPallet: null
    }
  },
  mutations: {
    setLoading(state, payload){
      state.palletPlanning.loading = payload;
    },

    setSelectedPallet(state, payload) {
      state.palletPlanning.selectedPallet = payload;
    },

    setStatusNames(state, payload) {
      state.statusNames = payload;
    },

    setStatusRights(state, payload) {
      state.statusRights = payload;
    },

    setTruck(state, payload) {
      state.palletPlanning.truck = payload;
    },

    setOrders(state, payload) {
      state.palletPlanning.orders = payload;
    },

    setPallets(state, payload) {
      state.palletPlanning.pallets = payload;
    },

    addSelectedProduct(state, payload) {
      const found = state.palletPlanning.selectedProducts.map(e => { return e.id}).indexOf(payload.id);
      if(found == -1){
        state.palletPlanning.selectedProducts.push(payload);
      }
    },

    removeSelectedProduct(state, payload) {
      const found = state.palletPlanning.selectedProducts.map(e => {return e.id}).indexOf(payload.id)
      if(found != -1){
        state.palletPlanning.selectedProducts.splice(found, 1);
      }
    },

    setSettings(state, payload) {
      state.palletPlanning.settings = payload;
    }
  },
  actions: {},
  getters: {
    getLoading(state){
      return state.palletPlanning.loading;
    },
    getSelectedPallet(state) {
      return state.palletPlanning.selectedPallet;
    },
    getStatusRights(state) {
      return state.statusRights;
    },

    getStatusNames(state) {
      return state.statusNames;
    },
    getOrders(state) {
      return state.palletPlanning.orders;
    },
    getPallets(state) {
      return state.palletPlanning.pallets;
    },
    getTruck(state) {
      return state.palletPlanning.truck;
    },
    getSelectedProducts(state) {
      return state.palletPlanning.selectedProducts;
    },
    getSettings(state) {
      return state.palletPlanning.settings;
    },
    getPalletColors(state) {
      return state.palletPlanning.palletColors;
    }
  }
});
